import { Client, WhoisEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class WhoisEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.WHOIS, (event: WhoisEvent) => {
            const { away, nick, ident, hostname, actual_ip, actual_hostname, actual_username, real_name, helpop, bot, server, server_info,
                operator, channels, modes, idle, logon, registered_nick, account, secure, special, error, tags, time } = event;
            const targetTab = this.tM.getActiveTab() ?? this.tM.getStatusTab();

            if (nick && hostname && ident && real_name) {
                this.mH.addMessage(targetTab, `* ${nick} is ${ident}@${hostname} * ${real_name}`, IRCMessageType.WHOIS);
            }
            if (actual_ip && actual_hostname) {
                this.mH.addMessage(targetTab, `* ${nick} is connecting from ${actual_ip} (${actual_hostname})`, IRCMessageType.WHOIS);
            }
            if (away) {
                this.mH.addMessage(targetTab, `* ${nick} is away: ${away}`, IRCMessageType.WHOIS);
            }
            if (helpop) {
                this.mH.addMessage(targetTab, `* ${nick} is available for help: ${helpop}`, IRCMessageType.WHOIS);
            }
            if (bot) {
                this.mH.addMessage(targetTab, `* ${nick} is a BOT`, IRCMessageType.WHOIS);
            }
            if (operator) {
                this.mH.addMessage(targetTab, `* ${nick} ${operator}`, IRCMessageType.WHOIS);
            }
            if (modes) {
                this.mH.addMessage(targetTab, `* ${nick} ${modes}`, IRCMessageType.WHOIS);
            }
            if (channels) {
                const channelList = channels.toString().replace(/[@+%~]/g, '');
                this.mH.addMessage(targetTab, `* ${nick} is on ${channelList}`, IRCMessageType.WHOIS);
            }
            if (server) {
                this.mH.addMessage(targetTab, `* ${nick} is using server: ${server} [${server_info}]`, IRCMessageType.WHOIS);
            }
            if (secure) {
                this.mH.addMessage(targetTab, `* ${nick} is using a Secure Connection`, IRCMessageType.WHOIS);
            }
            if (account) {
                this.mH.addMessage(targetTab, `* ${nick} is logged in as [${account}]`, IRCMessageType.WHOIS);
            }
            if (registered_nick) {
                this.mH.addMessage(targetTab, `* ${nick} ${registered_nick}`, IRCMessageType.WHOIS);
            }
            if (logon) {
                const logonDate = new Date(logon * 1000).toLocaleString();
                this.mH.addMessage(targetTab, `* ${nick} logged on at ${logonDate}`, IRCMessageType.WHOIS);
            }
            if (idle) {
                const idleMinutes = Math.floor(idle / 60);
                const idleHours = Math.floor(idleMinutes / 60);
                const idleDays = Math.floor(idleHours / 24);
                let idleStr = '';
                if (idleDays > 0) {
                    idleStr += `${idleDays} day${idleDays > 1 ? 's' : ''}, `;
                }
                if (idleHours % 24 > 0) {
                    idleStr += `${idleHours % 24} hour${(idleHours % 24) > 1 ? 's' : ''}, `;
                }
                if (idleMinutes % 60 > 0) {
                    idleStr += `${idleMinutes % 60} minute${(idleMinutes % 60) > 1 ? 's' : ''}, `;
                }
                idleStr += `${idle % 60} second${(idle % 60) !== 1 ? 's' : ''}`;
                idleStr = idleStr.replace(/, $/, '');

                this.mH.addMessage(targetTab, `* ${nick} has been idle for ${idleStr}`, IRCMessageType.WHOIS);
            }
            if (special) {
                this.mH.addMessage(targetTab, `* ${nick} ${special}`, IRCMessageType.WHOIS);
            }
            this.mH.addMessage(targetTab, `* End of /WHOIS list for ${nick}`, IRCMessageType.WHOIS);
        });
    }
}